import { Currency } from '@commercetools/frontend-sdk/lib/types/Currency';

export type REGION = 'US' | 'CA' | 'EU';

interface LocalizationMapping {
  locale: string;
  localeName: string;
  currency: Currency;
  currencyCode: string;
  countryName: string;
  countryCode: string;
  countries: Array<string>;
  region: REGION
}

const localizationMapper: Record<string, LocalizationMapping> = {
  'en-us': {
    locale: 'en-US',
    localeName: 'English',
    currency: 'USD',
    currencyCode: '$',
    countryCode: 'US',
    countryName: 'United States',
    countries: ['US'],
    region: 'US',
  },
  'en-ca': {
    locale: 'en-CA',
    localeName: 'English',
    currency: 'CAD',
    currencyCode: '$',
    countryCode: 'CA',
    countryName: 'Canada',
    countries: ['CA'],
    region: 'CA',
  },
  'fr-ca': {
    locale: 'fr-CA',
    localeName: 'French',
    currency: 'CAD',
    currencyCode: '$',
    countryCode: 'CA',
    countryName: 'Canada',
    countries: ['CA'],
    region: 'CA',
  },
  'de-at': {
    locale: 'de-AT',
    localeName: 'German',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'AT',
    countryName: 'Austria',
    countries: ['AT', 'BE'],
    region: 'EU',
  },
  'nl-be': {
    locale: 'nl-BE',
    localeName: 'Dutch',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'BE',
    countryName: 'Belgium',
    countries: ['BE'],
    region: 'EU',
  },
  'fr-be': {
    locale: 'fr-BE',
    localeName: 'French',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'BE',
    countryName: 'Belgium',
    countries: ['BE'],
    region: 'EU',
  },
  'bg-bg': {
    locale: 'bg-BG',
    localeName: 'Bulgarian',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'BG',
    countryName: 'Bulgaria',
    countries: ['BG'],
    region: 'EU',
  },
  'hr-hr': {
    locale: 'hr-HR',
    localeName: 'Croatian',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'HR',
    countryName: 'Croatia',
    countries: ['HR'],
    region: 'EU',
  },
  'el-cy': {
    locale: 'el-CY',
    localeName: 'Greek',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'CY',
    countryName: 'Cyprus',
    countries: ['CY'],
    region: 'EU',
  },
  'tr-cy': {
    locale: 'tr-CY',
    localeName: 'Turkish',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'CY',
    countryName: 'Cyprus',
    countries: ['CY'],
    region: 'EU',
  },
  'cs-cz': {
    locale: 'cs-CZ',
    localeName: 'Czech',
    currency: 'CZK',
    currencyCode: 'Kč',
    countryCode: 'CZ',
    countryName: 'Czechia',
    countries: ['CZ'],
    region: 'EU',
  },
  'da-dk': {
    locale: 'da-DK',
    localeName: 'Danish',
    currency: 'DKK',
    currencyCode: 'kr',
    countryCode: 'DK',
    countryName: 'Denmark',
    countries: ['DK'],
    region: 'EU',
  },
  'et-ee': {
    locale: 'et-EE',
    localeName: 'Estonian',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'EE',
    countryName: 'Estonia',
    countries: ['EE'],
    region: 'EU',
  },
  'fi-fi': {
    locale: 'fi-FI',
    localeName: 'Finnish',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'FI',
    countryName: 'Finland',
    countries: ['FI'],
    region: 'EU',
  },
  'sv-fi': {
    locale: 'sv-FI',
    localeName: 'Swedish',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'FI',
    countryName: 'Finland',
    countries: ['FI'],
    region: 'EU',
  },
  'fr-fr': {
    locale: 'fr-FR',
    localeName: 'French',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'FR',
    countryName: 'France',
    countries: ['FR'],
    region: 'EU',
  },
  'de-de': {
    locale: 'de-DE',
    localeName: 'German',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'DE',
    countryName: 'Germany',
    countries: ['DE'],
    region: 'EU',
  },
  'el-gr': {
    locale: 'el-GR',
    localeName: 'Greek',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'GR',
    countryName: 'Greece',
    countries: ['GR'],
    region: 'EU',
  },
  'hu-hu': {
    locale: 'hu-HU',
    localeName: 'Hungarian',
    currency: 'HUF',
    currencyCode: 'Ft',
    countryCode: 'HU',
    countryName: 'Hungary',
    countries: ['HU'],
    region: 'EU',
  },
  'en-ie': {
    locale: 'en-IE',
    localeName: 'English',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'IE',
    countryName: 'Ireland',
    countries: ['IE'],
    region: 'EU',
  },
  'it-it': {
    locale: 'it-IT',
    localeName: 'Italian',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'IT',
    countryName: 'Italy',
    countries: ['IT'],
    region: 'EU',
  },
  'lv-lv': {
    locale: 'lv-LV',
    localeName: 'Latvian',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'LV',
    countryName: 'Latvia',
    countries: ['LV'],
    region: 'EU',
  },
  'lt-lt': {
    locale: 'lt-LT',
    localeName: 'Lithuanian',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'LT',
    countryName: 'Lithuania',
    countries: ['LT'],
    region: 'EU',
  },
  'fr-lu': {
    locale: 'fr-LU',
    localeName: 'French',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'LU',
    countryName: 'Luxembourg',
    countries: ['LU'],
    region: 'EU',
  },
  'de-lu': {
    locale: 'de-LU',
    localeName: 'German',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'LU',
    countryName: 'Luxembourg',
    countries: ['LU'],
    region: 'EU',
  },
  'lb-lu': {
    locale: 'lb-LU',
    localeName: 'Luxembourgish',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'LU',
    countryName: 'Luxembourg',
    countries: ['LU'],
    region: 'EU',
  },
  'mt-mt': {
    locale: 'mt-MT',
    localeName: 'Maltese',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'MT',
    countryName: 'Malta',
    countries: ['MT'],
    region: 'EU',
  },
  'en-mt': {
    locale: 'en-MT',
    localeName: 'English',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'MT',
    countryName: 'Malta',
    countries: ['MT'],
    region: 'EU',
  },
  'nl-nl': {
    locale: 'nl-NL',
    localeName: 'Dutch',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'NL',
    countryName: 'Netherlands',
    countries: ['NL'],
    region: 'EU',
  },
  'pl-pl': {
    locale: 'pl-PL',
    localeName: 'Polish',
    currency: 'PLN',
    currencyCode: 'zł',
    countryCode: 'PL',
    countryName: 'Poland',
    countries: ['PL'],
    region: 'EU',
  },
  'pt-pt': {
    locale: 'pt-PT',
    localeName: 'Portuguese',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'PT',
    countryName: 'Portugal',
    countries: ['PT'],
    region: 'EU',
  },
  'ro-ro': {
    locale: 'ro-RO',
    localeName: 'Romanian',
    currency: 'RON',
    currencyCode: 'lei',
    countryCode: 'RO',
    countryName: 'Romania',
    countries: ['RO'],
    region: 'EU',
  },
  'sk-sk': {
    locale: 'sk-SK',
    localeName: 'Slovak',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'SK',
    countryName: 'Slovakia',
    countries: ['SK'],
    region: 'EU',
  },
  'sl-si': {
    locale: 'sl-SI',
    localeName: 'Slovene',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'SI',
    countryName: 'Slovenia',
    countries: ['SI'],
    region: 'EU',
  },
  'es-es': {
    locale: 'es-ES',
    localeName: 'Spanish',
    currency: 'EUR',
    currencyCode: '€',
    countryCode: 'ES',
    countryName: 'Spain',
    countries: ['ES'],
    region: 'EU',
  },
  'sv-se': {
    locale: 'sv-SE',
    localeName: 'Swedish',
    currency: 'SEK',
    currencyCode: 'kr',
    countryCode: 'SE',
    countryName: 'Sweden',
    countries: ['SE'],
    region: 'EU',
  },
  'en-gb': {
    locale: 'en-GB',
    localeName: 'English',
    currency: 'GBP',
    currencyCode: '£',
    countryCode: 'GB',
    countryName: 'United Kingdom',
    countries: ['GB'],
    region: 'EU',
  },
  'nb-no': {
    locale: 'nb-NO',
    localeName: 'Norwegian Bokmål',
    currency: 'NOK',
    currencyCode: 'kr',
    countryCode: 'NO',
    countryName: 'Norway',
    countries: ['NO'],
    region: 'EU',
  },
  'de-ch': {
    locale: 'de-CH',
    localeName: 'German',
    currency: 'CHF',
    currencyCode: 'CHF',
    countryCode: 'CH',
    countryName: 'Switzerland',
    countries: ['CH'],
    region: 'EU',
  },
  'fr-ch': {
    locale: 'fr-CH',
    localeName: 'French',
    currency: 'CHF',
    currencyCode: 'CHF',
    countryCode: 'CH',
    countryName: 'Switzerland',
    countries: ['CH'],
    region: 'EU',
  },
  'it-ch': {
    locale: 'it-CH',
    localeName: 'Italian',
    currency: 'CHF',
    currencyCode: 'CHF',
    countryCode: 'CH',
    countryName: 'Switzerland',
    countries: ['CH'],
    region: 'EU',
  },
  'is-is': {
    locale: 'is-IS',
    localeName: 'Icelandic',
    currency: 'ISK',
    currencyCode: 'kr',
    countryCode: 'IS',
    countryName: 'Iceland',
    countries: ['IS'],
    region: 'EU',
  },
  'de-li': {
    locale: 'de-LI',
    localeName: 'German',
    currency: 'CHF',
    currencyCode: 'CHF',
    countryCode: 'LI',
    countryName: 'Liechtenstein',
    countries: ['LI'],
    region: 'EU',
  },
};

const locales = Object.keys(localizationMapper);
const defaultLocale = locales[0];

export const i18nConfig = { locales, defaultLocale };

export const getLocalizationInfo = (locale: string) => {
  if (!(locale in localizationMapper)) {
    console.warn(`Invalid locale`);

    return localizationMapper[defaultLocale];
  }

  return localizationMapper[locale];
};

export const US_LOCALE = 'US';
export const CA_LOCALE = 'CA';
export const EU_LOCALE = 'EU';
export const NORTH_AMERICA_LOCALES = [US_LOCALE, CA_LOCALE];
export const M2H_ONLY_LOCALES = [CA_LOCALE, EU_LOCALE];

export const ALLOW_SHIPPING_TO_OTHER_COUNTRIES = false;

export const getLocaleForCountry = (country: string): string => {
  const countryLocales = Object.entries(localizationMapper)
    .filter(([_, mapping]) => mapping.countryCode.toLowerCase() === country.toLowerCase())
    .map(([locale, _]) => locale);

  return countryLocales[0] || defaultLocale;
};

export const supportedCountries = Object.values(localizationMapper)
  .reduce<{ name: string; code: string }[]>((acc, mapping) => {
    if (!acc.some((c) => c.code === mapping.countryCode)) {
      acc.push({ name: mapping.countryName, code: mapping.countryCode });
    }
    return acc;
  }, [])
  .sort((a, b) => a.name.localeCompare(b.name));
